import type { RecentKeyword } from '@/shared/lib/storage/recentKeywords';
import type { RecentAsset } from '@/shared/types/recentAssets';

import { SearchResultKeyword } from '@/features/dataSearch/ui/SearchResultKeyword';
import { SearchResultRecent } from '@/features/dataSearch/ui/SearchResultRecent';

import styles from './SearchResultRecentSection.module.css';

type SearchResultRecentSectionProps = {
  recentAssets: RecentAsset[];
  recentKeywords: RecentKeyword[];
  onClickRecentAsset: (asset: RecentAsset) => void;
  onClickKeyword: (keyword: string) => void;
  onClickRemoveKeyword: (keyword: string) => void;
};

export const SearchResultRecentSection = ({
  recentAssets,
  recentKeywords,
  onClickRecentAsset,
  onClickKeyword,
  onClickRemoveKeyword,
}: SearchResultRecentSectionProps) => {
  const hasRecentKeywords = recentKeywords.length > 0;
  const hasRecentAssets = recentAssets.length > 0;
  const hasAnyRecentData = hasRecentKeywords || hasRecentAssets;

  if (!hasAnyRecentData) {
    return <div className={styles.emptyState}>최근 항목이 없습니다</div>;
  }

  return (
    <>
      {hasRecentKeywords && (
        <SearchResultKeyword
          recentKeywords={recentKeywords}
          onClickKeyword={onClickKeyword}
          onClickRemoveKeyword={onClickRemoveKeyword}
        />
      )}
      {hasRecentAssets && <SearchResultRecent recentAssets={recentAssets} onClickRecentAsset={onClickRecentAsset} />}
    </>
  );
};
